// Module
var code = "<div class=\"splash-message text-center\" data-bind=\"text: NoControlsMessage\"></div>";
// Exports
export default code;